import React from 'react';
import { bonuses } from '../data/content';
import { SectionTitle } from './SectionTitle';
import { Accordion } from './Accordion';
export function BonusSection() {
  return <section className="defer-paint bg-botanic px-5 py-10" data-id="element-35" data-mp="22fmxh06uic3p">
      <SectionTitle data-id="element-36" data-mp="22f3f5ida9lp5">🎁 Además te llevás estos bonos exclusivos de regalo</SectionTitle>

      <div className="mt-6 space-y-3" data-id="element-37" data-mp="1yfcs9pqvnppw">
        {bonuses.map((bonus, i) => <Accordion key={bonus.id} id={bonus.id} className="bg-night" openClassName="bg-gold/[0.05]" header={<span className="flex items-start gap-3" data-id="element-39" data-mp="15pm8p16h7vme">
                <span className="font-display text-[18px] font-bold text-gold" data-id="element-40" data-mp="15r75yyk6dsny">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="font-sans text-[15px] font-semibold leading-snug text-ivory" data-id="element-41" data-mp="1epsl0jqfupjz">
                  {bonus.emoji} {bonus.title}
                </span>
              </span>} data-id="element-38" data-mp="1ao7av65agpdh" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-42" data-mp="mz4jh6kuri5s">
              <img id={bonus.id} src={bonus.image} alt={`Portada del ${bonus.title}`} loading="lazy" decoding="async" width={120} height={160} className="h-[160px] w-[120px] rounded object-cover shadow-[0_10px_28px_rgba(62,107,59,0.22)]" data-id="element-43" data-mp="mymjbyv2kjsl" />
              <p className="mt-4 font-sans text-[15px] leading-relaxed text-ivory/85" data-id="element-44" data-mp="2ji66e9t4knoa">
                {bonus.description}
              </p>
            </div>
          </Accordion>)}
      </div>
    </section>;
}